import { apiClient, toApiUrl, toApiUrls } from "api/client";

// match row는 categoryList, categoryListName, imageUrls 등 배열 필드를 JSON 문자열로 저장한다.
// 호출측이 배열로 기대하므로 파싱하여 정규화한다.
const ARRAY_FIELDS = [
  "categoryList",
  "categoryListName",
  "imageUrls",
  "selectedImages",
];

export function normalizeMatchRow(row) {
  if (!row) return row;
  const normalized = { ...row };
  for (const key of ARRAY_FIELDS) {
    const v = normalized[key];
    if (typeof v === "string") {
      try {
        normalized[key] = JSON.parse(v) || [];
      } catch {
        normalized[key] = [];
      }
    } else if (!Array.isArray(v) && v == null) {
      normalized[key] = [];
    }
  }
  // 업로드 URL 은 IIS/dev 프록시가 라우팅 가능한 "/api/uploads/..." 로 보정.
  normalized.imageUrls = toApiUrls(normalized.imageUrls);
  if (normalized.voiceUrl) normalized.voiceUrl = toApiUrl(normalized.voiceUrl);
  return normalized;
}

function normalizeList(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.map(normalizeMatchRow);
}

// ==================== GET ====================

export async function getMyMatchesApi(userId, { page = 1, limit = 20, status } = {}) {
  const params = { userId, page, limit };
  if (status) params.status = status;
  const { data } = await apiClient.get("/get/match/my", { params });
  return normalizeList(data);
}

export async function getRequiredApi() {
  const { data } = await apiClient.get("/get/match/required");
  return normalizeList(data);
}

export async function getDoneMatchApi(expertId) {
  const { data } = await apiClient.get("/get/match/done", { params: { expertId } });
  return normalizeList(data);
}

export async function getMatchDetailApi(docId) {
  const { data } = await apiClient.get("/get/match/detail", { params: { docId } });
  if (Array.isArray(data)) return data.map(normalizeMatchRow);
  return data ? normalizeMatchRow(data) : null;
}

export async function getMatchCountApi({ id, status, field } = {}) {
  const { data } = await apiClient.get("/get/match/count", {
    params: { id, status, field },
  });
  if (typeof data === "number") return data;
  if (data && typeof data.count === "number") return data.count;
  return 0;
}

export async function getRequiredPageApi({ page = 1, limit = 20, category, region } = {}) {
  const { data } = await apiClient.get("/get/match/requiredPage", {
    params: { page, limit, category, region },
  });
  return normalizeList(data);
}

export async function getDonePageApi(expertId, { page = 1, limit = 20, category } = {}) {
  const { data } = await apiClient.get("/get/match/donePage", {
    params: { expertId, page, limit, category },
  });
  return normalizeList(data);
}

export async function getMatchSearchApi({ name, address } = {}) {
  const { data } = await apiClient.get("/get/match/search", {
    params: { name, address },
  });
  return normalizeList(data);
}

// ==================== POST ====================

export async function createMatchApi(body) {
  const { data } = await apiClient.post("/post/match/create", body);
  return data;
}

export async function updateMatchApi(body) {
  const { data } = await apiClient.post("/post/match/update", body);
  return data;
}

export async function editMatchApi(body) {
  const { data } = await apiClient.post("/post/match/edit", body);
  return data;
}

export async function updateMatchImagesApi(body) {
  const { data } = await apiClient.post("/post/match/updateImages", body);
  return data;
}

export async function deleteMatchApi(docId) {
  const { data } = await apiClient.post("/post/match/delete", { docId });
  return data;
}

export async function acceptMatchApi(body) {
  const { data } = await apiClient.post("/post/match/accept", body);
  return data;
}

// ==================== 매칭 신청 (지원-선택 모델) ====================

// 수리기사가 요청에 신청 (포인트는 농가가 선택할 때 차감)
export async function applyMatchApi(body) {
  const { data } = await apiClient.post("/post/match/apply", body);
  return data;
}

// 신청자 목록 (이름 + 평점만)
export async function getApplicantsApi(matchDocId) {
  const { data } = await apiClient.get("/get/match/applicants", {
    params: { matchDocId },
  });
  return Array.isArray(data) ? data : [];
}

// 농가가 신청 거절
export async function rejectApplyApi(applyDocId) {
  const { data } = await apiClient.post("/post/match/applyReject", { applyDocId });
  return data;
}

// 농가가 신청 선택 → 매칭 확정 (선택된 기사 100P 차감)
export async function selectApplyApi(matchDocId, applyDocId) {
  const { data } = await apiClient.post("/post/match/applySelect", {
    matchDocId,
    applyDocId,
  });
  return data;
}

// ==================== rating ====================

export async function getRatingApi(expertId) {
  const { data } = await apiClient.get("/get/rating", { params: { expertId } });
  return Array.isArray(data) ? data : [];
}

export async function postMatchRatingApi(body) {
  const { data } = await apiClient.post("/post/match/rating", body);
  return data;
}
